export const SITE_ORIGIN = 'https://basecontable.vercel.app';
export const DEFAULT_OG_IMAGE_PATH = '/og-image.png';

export const DEFAULT_TITLE = 'Contsuite | Cobranzas para PyMEs y cierre de mes';
export const DEFAULT_DESCRIPTION =
  'Cobranzas para PyMEs en Argentina: prioridad de cobro, recordatorios automáticos y pack al contador. Cierre de mes ordenado. Registro interno sin facturación ARCA.';

export const PUBLIC_PAGES = {
  '/': {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
  },
  '/planes': {
    title: 'Planes Contsuite | Cobranzas PyME y pack al contador',
    description:
      'Planes de Contsuite para cobranzas de PyMEs: prioridad de cobro, pack mensual al contador y cierre de mes. 30 días de prueba. Registro interno sin facturación ARCA.',
  },
  '/funcionalidades': {
    title: 'Funcionalidades Contsuite | Prioridad de cobro y cierre de mes',
    description:
      'Prioridad de cobro, secuencias, score por cliente, pack al contador y cierre de mes. Cobranzas para PyMEs en Argentina. Registro interno sin facturación ARCA.',
  },
  '/quienes-somos': {
    title: 'Quiénes somos | Contsuite',
    description:
      'Contsuite es cobranzas para PyMEs en Argentina: prioridad de cobro, cierre de mes y pack al contador. La capa entre el Excel y el estudio. Sin facturación ARCA.',
  },
  '/ayuda': {
    title: 'Ayuda | Contsuite',
    description:
      'Preguntas frecuentes sobre cobranzas PyME, prioridad de cobro, pack al contador y cierre de mes con Contsuite. Registro interno sin facturación ARCA.',
  },
  '/contacto': {
    title: 'Contacto | Contsuite',
    description:
      'Escribinos por cobranzas PyME, pack al contador o planes de Contsuite. Respuesta en 24 h hábiles. CABA, Argentina.',
  },
  '/login': {
    title: 'Ingresar | Contsuite',
    description:
      'Entrá a Contsuite para gestionar cobranzas, prioridad de cobro y el cierre de mes de tu PyME.',
  },
  '/register': {
    title: 'Registro | Contsuite — cobranzas para PyMEs',
    description:
      'Creá tu cuenta Contsuite: cobranzas para PyMEs, prioridad de cobro y pack al contador. 30 días de prueba. Registro interno sin facturación ARCA.',
  },
  '/forgot-password': {
    title: 'Recuperar contraseña | Contsuite',
    description: 'Recuperá el acceso a tu cuenta Contsuite para seguir con las cobranzas de tu PyME.',
  },
};

const PRIVATE_PREFIXES = [
  '/inicio',
  '/home',
  '/dashboard',
  '/clientes',
  '/clientes-detalle',
  '/facturas',
  '/egresos',
  '/cobranzas',
  '/reportes',
  '/cuenta',
  '/contador',
  '/admin',
  '/equipo',
  '/auditoria',
  '/uso-plan',
  '/pago',
  '/completar-perfil',
  '/aceptar-contador',
  '/restablecer-clave',
  '/paises-detalle',
  '/facturas-impagas-detalle',
  '/distribucion-clientes-detalle',
  '/movil',
];

function isPrivatePath(pathname) {
  return PRIVATE_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

export function getPageSeo(pathname) {
  const publicPage = PUBLIC_PAGES[pathname];
  if (publicPage) {
    return {
      ...publicPage,
      path: pathname,
      robots: 'index, follow',
    };
  }

  if (isPrivatePath(pathname)) {
    return {
      title: 'Contsuite',
      description: DEFAULT_DESCRIPTION,
      path: pathname,
      robots: 'noindex, nofollow',
    };
  }

  return {
    title: 'Página no encontrada | Contsuite',
    description: DEFAULT_DESCRIPTION,
    path: pathname,
    robots: 'noindex, follow',
  };
}

export const ORGANIZATION_JSON_LD = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${SITE_ORIGIN}/#organization`,
      name: 'Contsuite',
      url: SITE_ORIGIN,
      logo: `${SITE_ORIGIN}/bsola2.png`,
      email: 'contsuite@gmail.com',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'CABA',
        addressCountry: 'AR',
      },
    },
    {
      '@type': 'SoftwareApplication',
      '@id': `${SITE_ORIGIN}/#software`,
      name: 'Contsuite',
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'Web',
      url: SITE_ORIGIN,
      image: `${SITE_ORIGIN}${DEFAULT_OG_IMAGE_PATH}`,
      description: DEFAULT_DESCRIPTION,
      offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'ARS',
        description: '30 días de prueba',
      },
      publisher: { '@id': `${SITE_ORIGIN}/#organization` },
    },
  ],
};
